import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { getCronTriggerPath } from '~entities/stripe/lib/cron-api-path';
import { baseAPI } from '~shared/api/base-api';

interface TriggerScheduledInvoicesParams {
  isV2: boolean;
}

export const triggerScheduledInvoices = async (
  params: TriggerScheduledInvoicesParams,
) => {
  const response = await baseAPI.post<{ ok?: true }>(
    getCronTriggerPath('scheduled-invoices', params.isV2),
  );
  return response.data;
};

export const useTriggerScheduledInvoices = () => {
  return useMutation({
    mutationFn: triggerScheduledInvoices,
    onSuccess: () => {
      toast.success('Scheduled invoices cron triggered successfully');
    },
    onError: (error: unknown) => {
      const errorMessage =
        error &&
        typeof error === 'object' &&
        'response' in error &&
        error.response &&
        typeof error.response === 'object' &&
        'data' in error.response &&
        error.response.data &&
        typeof error.response.data === 'object' &&
        'message' in error.response.data &&
        typeof error.response.data.message === 'string'
          ? error.response.data.message
          : 'Failed to trigger scheduled invoices cron.';

      toast.error(errorMessage);
    },
  });
};
